import type { BusinessParameterInfo } from '../hooks';

interface BusinessRevenueInfoProps {
  parameter: BusinessParameterInfo;
}

export function BusinessRevenueInfo({ parameter }: BusinessRevenueInfoProps) {
  const { rewards } = parameter;

  return (
    <div className="space-y-2 text-sm">
      <h4 className="font-medium">Rewards</h4>
      <div className="space-y-1">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Mode</span>
          <span className="capitalize">{rewards.mode}</span>
        </div>
        {rewards.heptals > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Heptals</span>
            <span>{rewards.heptals.toLocaleString()}</span>
          </div>
        )}
        {rewards.bonusItem && rewards.bonusCount > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">{rewards.bonusItem}</span>
            <span>{rewards.bonusCount}</span>
          </div>
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        Final rewards affected by subscription tier and Epic Land bonus.
      </p>
    </div>
  );
}
